import { render, staticRenderFns } from "./my.vue?vue&type=template&id=23ac35d6&scoped=true&"
import script from "./my.vue?vue&type=script&lang=js&"
export * from "./my.vue?vue&type=script&lang=js&"
import style0 from "./my.vue?vue&type=style&index=0&lang=css&"
import style1 from "./my.vue?vue&type=style&index=1&id=23ac35d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac35d6",
  null
  
)

export default component.exports